export function DownloadBase64File(fileName: string, contentBase64: string) {
  const downloadLink = document.createElement('a')
  document.body.appendChild(downloadLink)

  downloadLink.href = contentBase64
  downloadLink.target = '_self'
  downloadLink.download = fileName
  downloadLink.click()
}
